{
  "title": "Подписки",
  "paginationTitle": "Подписки",
  "columns": {
    "name": "Название",
    "description": "Описание",
    "senders": "Способы уведомления",
    "sender": "Средства отправки",
    "actions": "Действия",
    "filter": "Фильтр",
    "integrationPoint": "Точка интеграции",
    "integrationPoints": "Точки интеграции",
    "chooseIntegrationPoint": "Выберите точку интеграции",
    "event": "Событие",
    "events": "События",
    "chooseEvent": "Выберите событие",
    "messageTemplate": "Шаблон сообщения",
    "template": "Шаблон",
    "nameFull": "Название",
    "addNameFull": "Введите название",
    "type": "Тип",
    "chooseType": "Выберите тип",
    "host": "Хост",
    "chooseHost": "Выберите хост",
    "port": "Порт",
    "choosePort": "Выберите порт",
    "path": "Путь",
    "addUrl": "Добавьте URL-адрес пути",
    "mail": "Почта",
    "addMail": "Добавьте адрес почты",
    "incorrectMail": "Некорректный формат электронной почты",
    "subject": "Тема",
    "addSubject": "Добавьте тему",
    "byDefault": "Основной",
    "byDefaultDialog": "Сделать основным - использовать шаблон для отправки уведомлений пользователям"
  },
  "senders": {
    "telegram": "Телеграмм",
    "email": "Почта",
    "bell": "Уведомления"
  },
  "filter": {
    "or": "ИЛИ",
    "and": "И",
    "cit": "Типы КЕ",
    "hi": "Индикаторы здоровья",
    "values": "Значения",
    "hiIndicators": "Типы индикаторов",
    "citAttributes": "Атрибуты КЕ"
  },
  "external-services": {
    "configuration": "Конфигурация",
    "title": "Внешние сервисы",
    "list": "Список сервисов",
    "listEmpty": "Список сервисов пуст",
    "one-service": "Внешний сервис",
    "subscription": "Подписка",
    "subscriptions": "Подписки",
    "integration-points": "Точки интеграции",
    "empty": "Выберите или создайте внешний сервис",
    "createIntegrationPoint": "Cоздайте точку интеграции"
  },
  "success": {
    "delete": "Успешно удалено",
    "add": "Успешно добавлено",
    "upgrade": "Успешно обновлено"
  },
  "template": {
    "list": "Список событий",
    "main": "Шаблон",
    "createTemplate": "Введите шаблон",
    "choose": "Выберите шаблон",
    "empty": "Выберите или создайте шаблон",
    "templateTheme": "Тема шаблона",
    "addTemplateTheme": "Введите тему шаблона",
    "type": "Тип",
    "chooseType": "Выберите тип шаблона",
    "notificationTool": "Способ уведомления",
    "result": "Результат",
    "templateVariables": "Переменные шаблона",
    "checkTemplateValidity": "Проверить шаблон"
  },
  "receivers": {
    "title": "Список адресатов",
    "newElement": "Новый адресат",
    "name": "Название",
    "active_time_interval": "Интервал отправки",
    "mute_time_interval": "Интервал тишины",
    "sender_name": "Имя отправителя",
    "address": "Адресат",
    "canals": "Каналы отправки уведомлений",
    "send_resolve": "Отправлять resolve",
    "sender_active": "Отправитель включен",
    "sender_not_active": "Отправитель отключен"
  },
  "deleteDialog": {
    "title": "Найдены зависимые элементы:"
  }
}